import React from 'react';
import PropTypes from 'prop-types';
import { GithubPicker } from 'react-color';

import { ColorPickerOverlay, ColorPickerContainer } from './styles';

const colors = [
  '#B80000',
  '#DB3E00',
  '#FCCB00',
  '#008B02',
  '#006B76',
  '#1273DE',
  '#004DCF',
  '#5300EB',
  '#EB9694',
  '#FAD0C3',
  '#FEF3BD',
  '#C1E1C5',
  '#BEDADC',
  '#C4DEF6',
  '#BED3F3',
  '#D4C4FB',
  '#000000',
  '#525252',
  '#969696',
  '#D9D9D9',
  '#FFFFFF',
];

const Picker = ({ visible, onChangeComplete, togglePicker }) => visible && (
  <ColorPickerContainer>
    <ColorPickerOverlay onClick={togglePicker} />
    <GithubPicker colors={colors} onChangeComplete={onChangeComplete} />
  </ColorPickerContainer>
);

Picker.propTypes = {
  visible: PropTypes.bool.isRequired,
  onChangeComplete: PropTypes.func.isRequired,
};

export default Picker;
